{
    "Title": "Detalhes do item de atividade ACD",
    "SectionTitleDatetimevalues": "VALORES DE DATA\/HORA",
    "SectionTitleDeviceandacdinfo": "INFORMAÇÕES SOBRE O DISPOSITIVO E ACD",
    "SectionTitleStatusvalues": "VALORES DE ESTADO",
    "SectionTitleAssociatedtelephonyenv": "AMBIENTE DE TELEFONIA ASSOCIADO",
    "SectionTitleDiagnosticvalues": "VALORES DE DIAGNÓSTICO",
    "ButtonHelp": "Ajuda",
    "ButtonClose": "Perto",
    "ColumnHeaderValue": "Valor",
    "ColumnHeaderFieldStatistic": "Campo \/ Estatística",
    "ButtonCollapseall": "Recolher todos",
    "NAME": "ACDDNDActivity"
}